import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import FormStatus from '../../../../components/ui/FormStatus/FormStatus'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'
import TextInput from '../../../../components/ui/SimplifiedLogin/TextInput/TextInput'
import mobileNumberInput from '../../../../services/input/mobileNumberInput'

const ButtonWrapper = styled.div`
  margin: 1rem 0 0;
`
const BlockButton = styled(ActionButton)`
  width: 100%;
  height: 52px;
  text-transform: none;
  font-weight: var(--font-weight-bold);
`

const LoginForm = props => {
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    isSubmitting,
    isValid,
    disabled,
    method,
    action,
    setStatus,
    status,
  } = props

  const clearStatus = () => {
    if (props.status && setStatus) setStatus({})
  }

  return (
    <form
      onSubmit={handleSubmit}
      method={method}
      action={action}
      data-testid="loginForm"
    >
      <fieldset disabled={isSubmitting || disabled}>
        <FormStatus variant={status.error ? 'error' : 'message'}>
          {status.error || status.message}
        </FormStatus>
        <TextInput
          name="username"
          type="text"
          bold="boldest"
          label="Login or Sign up with Mobile Number"
          placeholder="09xx1234567"
          maxLength={11}
          initialValue={values.username}
          error={errors.username}
          touched={touched.username}
          onChange={e => {
            mobileNumberInput(e, handleChange)
            clearStatus()
          }}
          onBlur={handleBlur}
          valueColor="secondary"
          data-testid="username"
        />
        <ButtonWrapper>
          <BlockButton
            type="submit"
            variant="secondary"
            disabled={!isValid}
            data-testid="loginSubmit"
          >
            Continue with Mobile Number
          </BlockButton>
        </ButtonWrapper>
      </fieldset>
    </form>
  )
}

LoginForm.defaultProps = {
  handleSubmit: null,
  handleChange: null,
  handleBlur: null,
  values: {},
  errors: {},
  touched: {},
  isSubmitting: false,
  isValid: false,
  disabled: false,
  method: 'get',
  action: '',
  status: {},
}

LoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
  touched: PropTypes.shape(),
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  method: PropTypes.oneOf(['get', 'post']),
  action: PropTypes.string,
  status: PropTypes.shape(),
}

export default LoginForm
